import React, { useState } from "react";
import { Modal, theme } from "antd";
import styled from "styled-components";
import { JsonEditor } from "../../../JsonEditor";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Preview = styled.div<{ $token: any }>`
  flex: 1;
  padding: 4px 8px;
  border-radius: 2px;
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 1.5;
  border: 1px solid ${props => props.$token.colorBorder};
  background-color: ${props => props.$token.colorBgContainer};
  color: ${props => props.$token.colorTextSecondary};
`;

const BindingIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ff4d4f;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  flex-shrink: 0;
`;

interface JsonSetterProps {
  value?: any;
  onChange?: (value: any) => void;
}

export const JsonSetter: React.FC<JsonSetterProps> = ({ value, onChange }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { token } = theme.useToken();

  const getSimplifiedPreview = (value: any): string => {
    if (!value) return "{}";

    if (Array.isArray(value)) {
      if (value.length === 0) return "[]";
      return `[${value.length} items]`;
    }

    if (typeof value === "object") {
      const keys = Object.keys(value);
      if (keys.length === 0) return "{}";
      return `{ ${keys[0]}: ${JSON.stringify(value[keys[0]]).slice(0, 10)}${
        keys.length > 1 ? ", ..." : ""
      } }`;
    }

    const stringValue = JSON.stringify(value);
    return stringValue.length > 20
      ? stringValue.slice(0, 20) + "..."
      : stringValue;
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Container>
        <Preview $token={token} title={JSON.stringify(value, null, 2)}>
          {getSimplifiedPreview(value)}
        </Preview>
        <BindingIcon onClick={() => setIsModalVisible(true)}>J</BindingIcon>
      </Container>

      <Modal
        title="编辑 JSON"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => setIsModalVisible(false)}
        width={800}
        styles={{
          body: {
            padding: "12px",
          }
        }}
      >
        <div style={{ height: "400px" }}>
          <JsonEditor
            value={JSON.stringify(value, null, 2)}
            onChange={(newValue) => {
              try {
                const jsonValue = JSON.parse(newValue || "{}");
                onChange?.(jsonValue);
              } catch (e) {
                console.error("Invalid JSON:", e);
              }
            }}
          />
        </div>
      </Modal>
    </>
  );
};
